// Authentication utility functions
export const clearAuthState = () => {
  // Clear all authentication-related localStorage items
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("cognitoUser");
  localStorage.removeItem("aws-amplify-cache");
  localStorage.removeItem("amplify-signin-with-hostedUI");
  localStorage.removeItem("amplify-signin-with-hostedUI-state");

  // Clear any other potential AWS Cognito cache items
  Object.keys(localStorage).forEach((key) => {
    if (
      key.includes("cognito") ||
      key.includes("amplify") ||
      key.includes("aws")
    ) {
      localStorage.removeItem(key);
    }
  });

  console.log("Auth state cleared");
};

export const isAuthenticated = () => {
  const token = localStorage.getItem("jwtToken");
  return !!token;
};

export const getAuthToken = () => {
  return localStorage.getItem("jwtToken");
};

export const setAuthToken = (token) => {
  localStorage.setItem("jwtToken", token);
};
